import { Controller } from "@hotwired/stimulus";
import gsap from "gsap";
import { SplitText } from "gsap/all";

// Connects to data-controller="hero"
export default class extends Controller {
  static targets = ["heading", "subheading", "cta", "background"];
  connect() {
    const headingSplit = SplitText.create(this.headingTarget, {
      type: "lines,words",
    });

    const subheadingSplit = SplitText.create(this.subheadingTarget, {
      type: "lines",
    });

    const tl = gsap.timeline({});

    gsap.from(this.backgroundTarget, {
      scale: "1.1",
      duration: 1,
    });

    gsap.from(headingSplit.lines, {
      rotationX: -100,
      transformOrigin: "50% 50% -160px",
      opacity: 0,
      duration: 0.8,
      ease: "power4.inOut",
      stagger: 0.06,
    });

    gsap.from(subheadingSplit.lines, {
      //rotationX: -100,
      //transformOrigin: "50% 50% -160px",
      yPercent: 100,
      opacity: 0,
      duration: 0.8,
      ease: "power4.inOut",
      stagger: 0.06,
      delay: 0.3,
    });

    gsap.from(this.ctaTarget, {
      //rotationX: -100,
      //transformOrigin: "50% 50% -160px",
      opacity: 0,
      yPercent: 100,
      duration: 0.8,
      ease: "power4.inOut",
      delay: 0.5,
    });
  }
}
